export default "__VITE_ASSET__06cf6be7__"